import React, { useState, useEffect } from 'react';
import './PropertiesList.css'; // Reuse existing styling
import rankingIcon from './imgs/ranking_icon.png'; // Import images
import binIcon from './imgs/bin.png';
import goldIcon from './imgs/gold.png';
import silverIcon from './imgs/silver.png';

function DemoPropertyList({ properties, selectedCharacteristics, onUpdateCharacteristics }) {
  const [localProperties, setLocalProperties] = useState(properties);

  useEffect(() => {
  setLocalProperties(properties);
}, [properties]);

  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [editedScores, setEditedScores] = useState({});

const calculateTotalScore = (scores) => {
    console.log(scores);
  return Object.entries(scores || {}).reduce((total, [char, score]) => {
    const weight = selectedCharacteristics[char] || 1; // Default weight to 1 if not set
    return total + Number(score) * weight;
  }, 0);
};

const handleDelete = (property) => {
  const isConfirmed = window.confirm(`Are you sure you want to delete "${property.property_name || 'this property'}"?`);
  if (isConfirmed) {
    setLocalProperties((prevProperties) => {
      const updatedProperties = prevProperties.filter(p => p.url !== property.url);
      return updatedProperties; // Keep existing scores
    });

    // Ensure it does not override scores in state
    setEditedScores((prevScores) => ({ ...prevScores }));

    if (onUpdateCharacteristics) {
      onUpdateCharacteristics((prev) => ({ ...prev }));
    }
  }
};

useEffect(() => {
  if (selectedProperty) {
    setEditedScores((prevScores) => ({
      ...selectedCharacteristics,
      ...prevScores,
    }));
  }
}, [selectedCharacteristics, selectedProperty]); 

const handleScore = (property) => {
  const updatedScores = { ...selectedCharacteristics, ...property.scores };
  setSelectedProperty({ ...property, scores: updatedScores });
  setEditedScores(updatedScores); // Use only editedScores
  setShowScoreModal(true);
};

const handleScoreChange = (characteristic, value) => {
  const newValue = parseInt(value, 10);

  setEditedScores((prevScores) => ({
    ...prevScores,
    [characteristic]: newValue,
  }));
};

const handleSubmitScores = () => {
  if (!selectedProperty) return;

  // Apply the changes from `editedScores` to `localProperties`
  setLocalProperties((prevProperties) => {
    const updatedProperties = prevProperties.map((property) =>
      property.url === selectedProperty.url
        ? { ...property, scores: { ...editedScores } }
        : property
    );
    return updatedProperties.sort((a, b) => calculateTotalScore(b.scores) - calculateTotalScore(a.scores));
  });

  setShowScoreModal(false); // Close the modal
};

  return (
    <div>
      <div className="properties-grid">
        {localProperties.map((property, index) => {
          let icon = index === 0 ? goldIcon : index === 1 ? silverIcon : null;

          return (
            <div key={index} className="property-card" style={{ backgroundImage: `url(${property.property_image})` }} onClick={() => handleScore(property)}>
              <div className="overlay">
                <div className="top-left">
                  {icon && <img src={icon} alt="Top score" className="top-tier-icon" />}
                  <span className="property-score">{Math.round(calculateTotalScore(property.scores))}</span>
                </div>
                <div className="top-right">
                  <button className="score-button" onClick={(e) => { e.stopPropagation(); handleScore(property); }}>
                    <img src={rankingIcon} alt="Rank this property" className="ranking-icon" />
                  </button>
                  <button className="delete-button" onClick={(e) => { e.stopPropagation(); handleDelete(property); }}>
                    <img src={binIcon} alt="Delete this property" className="bin-icon" />
                  </button>
                </div>
                <div className="bottom-left">
                  <p className="property-price">{property.price}</p>
                  <a href="#rightmoveproperty" target="" rel="noopener noreferrer" className="property-name-link" onClick={(e) => e.stopPropagation()}>
                    {property.property_name || 'Unnamed Property'}
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {showScoreModal && selectedProperty && (
  <div className="modal-overlay">
    <div className="score-property">
      <div style={{ padding: '20px' }}>
        <h2>{selectedProperty.property_name || "Unnamed Property"}</h2>
        <form>
          <table className="characteristics-table">
            <tbody>
              {Object.entries(selectedCharacteristics).map(([char, multiplier]) => (
                <tr key={char}>
                  <td>{char}</td>
                  <td>
                    <input
                      type="range"
                      min="1"
                      max="10"
                      style={{
                        background: `linear-gradient(to right, #6867FF 0%, #6867FF ${
                          ((editedScores[char] || 1) - 1) / 9 * 100
                        }%, #DDDDDD ${((editedScores[char] || 1) - 1) / 9 * 100}%, #DDDDDD 100%)`,
                      }}
                      value={editedScores[char] || 1}
                      onChange={(e) => {
                        const newValue = parseInt(e.target.value, 10);
                        handleScoreChange(char, newValue);
                        e.target.style.background = `linear-gradient(to right, #6867FF 0%, #6867FF ${
                          ((newValue - 1) / 9) * 100
                        }%, #DDDDDD ${((newValue - 1) / 9) * 100}%, #DDDDDD 100%)`;
                      }}
                    />
                  </td>
                  <td>
                    <span>{editedScores[char] || 1}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </form>
      </div>
      <div className="scoring-buttons">
        <button onClick={handleSubmitScores} className="save-button">Save Score</button>
        <button onClick={() => setShowScoreModal(false)} className="cancel-score-button">Cancel</button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default DemoPropertyList;
